import React from 'react';
import { ListItemChecked } from 'components/List';
import Styled from './styles';

export interface MoreButtonItemCheckedProps extends React.ComponentPropsWithRef<'div'> {
  /** The list items, consider using `MoreButtonItemText`. */
  children: React.ReactNode;
}

/** Group header for MoreButton menu items.
 * Any other props will be provided to the root element.
 */
const MoreButtonItemChecked = React.forwardRef<HTMLElement, MoreButtonItemCheckedProps>((props: MoreButtonItemCheckedProps, ref) => {
  const {
    children,
    ...otherProps
  } = props;

  return (
    <Styled.MoreButtonItemChecked>
      <ListItemChecked
        ref={ref}
        {...otherProps}
      >
        {children}
      </ListItemChecked>
    </Styled.MoreButtonItemChecked>
  );
});

MoreButtonItemChecked.displayName = 'MoreButtonItemChecked';

export default MoreButtonItemChecked;
